import { withInstall } from '@/utils'
import Tree from './src/tree.vue'
export default withInstall(Tree)
